import axios from 'axios';
import { ViewModel } from '../mobx/models/view';
import { REACT_APP_TEAMCAMP_APIURL } from '../global/environment';
import { captureException } from '@sentry/react';
import { getAPIErrorReason } from '../helpers/common';
import { rootStore } from '../mobx/rootStore';
import { formatToViewStore } from '../mobx/common';
import { RawView } from '../mobx/interfaces/view';

/**
 * @desc Project - tasks - create new task
 * @param {*}
 */
export const createNewView: any = (payload: ViewModel) => async () => {
  try {
    const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/views/createView`, payload);
    const { data } = response;
    if (data) {
      return data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to create view please try again';
    captureException(error);
    dispatchViewError(error);
    return false;
  }
};

/**
 * @desc View - Get view list
 */
export const getViewList: any = async () => {
  try {
    rootStore.viewStore.setLoading(true);
    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/views/getViews`);
    if (response?.data) {
      const activeViews = response.data.filter((view: any) => !view.IsArchived);
      const formattedViews = formatToViewStore(activeViews);
      rootStore.viewStore.setViews(formattedViews as RawView[]);
      rootStore.viewStore.updateViewPreferenceFromFirebase();
      return formattedViews;
    }
    return undefined;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get view list please try again';
    captureException(error);
    dispatchViewError(error);
    return false;
  } finally {
    rootStore.viewStore.setLoading(false);
  }
};

/* @desc update view data
 * @param {*}viewId
 */
export const updateView: any = (payload: RawView, viewId: string) => async () => {
  try {
    const response = await axios.put(`${REACT_APP_TEAMCAMP_APIURL}/views/updateView/${viewId}`, payload);
    if (response) {
      dispatchViewSuccess('View updated successfully');
      return true;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to update view data please try again';
    captureException(error);
    dispatchViewError(error);
    return false;
  }
};

/**
 * @desc View - Remove view
 * @param {*}
 */
export const removeView: any = (viewId: string) => async () => {
  try {
    rootStore.viewStore.setLoading(true);
    const response = await axios.delete(`${REACT_APP_TEAMCAMP_APIURL}/views/removeView/${viewId}`);
    if (response) {
      dispatchViewSuccess('View removed successfully');
      return true;
    }
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to remove view please try again';
    captureException(error);
    dispatchViewError(error);
    return false;
  } finally {
    rootStore.viewStore.setLoading(false);
  }
};

export function dispatchViewError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}

export function dispatchViewSuccess(msg: string) {
  rootStore.alertNotificationStore.setSuccessMessage(msg);
}
